import { render } from "./MessengerDetail.vue?vue&type=template&id=08d3943e"
import script from "./MessengerDetail.vue?vue&type=script&lang=js"
export * from "./MessengerDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__